<template>
  <div class="rescue-alliance">
    <!-- 主视觉区域 - 顶部横幅 -->
    <section class="hero">
      <!-- <div class="container">
        <div class="hero-content">
          <h1>江泰全球救援联盟</h1>
          <p>携手谋发展，同心赢未来</p>
        </div>
      </div> -->
    </section>

    <!-- 联盟介绍区域 -->
    <section class="alliance-intro">
      <div class="container">
        <h2 class="section-title">联盟介绍</h2>
        <div class="intro-content">
          <p>江泰全球救援联盟由江泰救援服务有限公司发起创立于2016年3月20日，是由全球知名的救援公司、包机公司、安保公司、律师事务所、旅行社、医疗机构、相关中介服务机构等自愿参与并组成的， 为中国公民走出去和境外人员走进来服务的全球性救援服务组织。200多个联盟成员 通过其服务网络，救援服务已经覆盖全球 200 多个国家和地区。</p>
        </div>
      </div>
    </section>

    <!-- 联盟成员分布区域 - 全球地图展示 -->
    <section class="alliance-distribution">
      <div class="container">
        <h2 class="section-title">联盟成员分布</h2>
        <div class="distribution-map" id="worldMap">
          <WorldMap :data="mapData2"/>
        </div>
      </div>
    </section>

    <!-- 部分联盟成员区域 - 成员卡片展示 -->
    <section class="alliance-members">
      <div class="container">
        <h2 class="section-title">部分联盟成员</h2>
        <div class="members-grid">
          <!-- 成员卡片 1 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union1.png" alt="联盟成员">
              <h3>Humanscare World Wide Medical</h3>
            </div>
            <div class="member-info">
              <p>救援公司（内地和香港地区）</p>
            </div>
          </div>
          
          <!-- 成员卡片 2 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union2.png" alt="联盟成员">
              <h3>LIP律师事务所</h3>
            </div>
            <div class="member-info">
              <p>律师事务所（马来西亚）</p>
            </div>
          </div>
          
          <!-- 成员卡片 3 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union3.png" alt="联盟成员">
              <h3>北京某救援所</h3>
            </div>
            <div class="member-info">
              <p>医疗机构（中国）</p>
            </div>
          </div>
          
          <!-- 成员卡片 4 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union4.png" alt="联盟成员">
              <h3>OCR Health International Ltd.</h3>
            </div>
            <div class="member-info">
              <p>救援公司（巴拿马和巴西）</p>
            </div>
          </div>
          
          <!-- 成员卡片 5 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union5.png" alt="联盟成员">
              <h3>Sirkka Networks 连可网络</h3>
            </div>
            <div class="member-info">
              <p>救援公司（德国）</p>
            </div>
          </div>
          
          <!-- 成员卡片 6 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union6.png" alt="联盟成员">
              <h3>CEL 蓝天救护社</h3>
            </div>
            <div class="member-info">
              <p>旅行社（罗马尼亚）</p>
            </div>
          </div>
          
          <!-- 成员卡片 7 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union7.png" alt="联盟成员">
              <h3>FULLERTON Global 24</h3>
            </div>
            <div class="member-info">
              <p>救援公司（澳大利亚）</p>
            </div>
          </div>
          
          <!-- 成员卡片 8 -->
          <div class="member-item">
            <div class="member-item-img">
              <img src="@/assets/images/rescueAlliance/union8.png" alt="联盟成员">
              <h3>MATTEO EMERGENCY</h3>
            </div>
            <div class="member-info">
              <p>律师事务所（中国）</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 加入联盟区域 - 行动号召 -->
    <section class="join-alliance">
      <div class="container">
        <div class="join-content">
          <h2>加入联盟，共创未来</h2>
          <button class="btn-primary" @click="showLoginModal">点击申请</button>
        </div>
      </div>
    </section>

    <!-- 大救星平台介绍 - 产品展示 -->
    <section class="rescue-platform">
      <div class="container">
        <div class="platform-content">
          <div class="platform-logo">
            <img src="@/assets/images/rescueAlliance/djx-logo.png" alt="大救星">
          </div>
          <div class="platform-text">
            <h2>大救星</h2>
            <h3>全球综合救援服务云平台</h3>
            <p>江泰全球救援联盟依托"大救星"大救星平台是江泰救援服务有限公司创立的全球综合救援智能云平台，总部位于中国北京。在传统医疗救援的基础上，致力于为全球用户提供涵盖救援、救治、救助、救护的"四救"综合服务，并衍生出包含紧急医疗转运、医疗送返在内的51大类服务内容。通过先进的智能技术，大救星为用户全球出行提供更专业、更全面的安全保障，有求必救，让救援服务触手可及。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务特色 - 五大特点展示 -->
    <section class="service-features">
      <div class="container">
        <h2 class="section-title">服务特色</h2>
        <div class="features-grid">
          <!-- 特色1：突破传统救援限制 -->
          <div class="feature-item">
            <div class="feature-title">突破传统救援限制</div>
            <div class="feature-content">
              <p>大救星救援服务为无户籍、无身份证明、无医保、无风险意识预案、无地理区域限制、无救援资源限制、无救援能力限制、无救援服务限制。</p>
            </div>
          </div>
          
          <!-- 特色2：独创便捷服务模式 -->
          <div class="feature-item">
            <div class="feature-title">独创便捷服务模式</div>
            <div class="feature-content">
              <p>平台在全球范围有可用中文及地道语言的"大救星伙伴"，可为用户提供"贴身管家"服务，代办各类贴心服务。</p>
            </div>
          </div>
          
          <!-- 特色3：一键救援快捷指挥 -->
          <div class="feature-item">
            <div class="feature-title">一键救援快捷指挥</div>
            <div class="feature-content">
              <p>用户可通过大救星小程序或官网的"一键救援"按钮直接求救，快速定位救援，救援人员，365天×24小时不间断响应。</p>
            </div>
          </div>
          
          <!-- 特色4：全球救援出行无忧 -->
          <div class="feature-item">
            <div class="feature-title">全球救援出行无忧</div>
            <div class="feature-content">
              <p>大救星救援服务覆盖全球233个国家和地区，全球8万余家医院和诊所，急救私人医生可随时随地为用户提供救援服务。</p>
            </div>
          </div>
          
          <!-- 特色5：有求必救不设门槛 -->
          <div class="feature-item">
            <div class="feature-title">有求必救不设门槛</div>
            <div class="feature-content">
              <p>无论是否购买了大救星产品，都可获得救援服务，根据用户需求提供收费救援、救助服务。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 大救星平台服务覆盖 -->
    <section class="platform-coverage">
      <div class="coverage-container">
        <!-- 中心LOGO -->
        <div class="platform-logo-center">
          <img src="@/assets/images/rescueAlliance/大救星.png" alt="大救星">
        </div>
        
        <!-- 左侧信息 -->
        <div class="coverage-info left-top">
          <p>星使覆盖138个国家和地区</p>
        </div>
        
        <div class="coverage-info left-middle">
          <p>星使覆盖城市820个(境外583,境内237)</p>
        </div>
        
        <div class="coverage-info left-bottom">
          <p>境内服务体系7位海外代表+服务商+海外星使</p>
        </div>
        
        <div class="coverage-info left-extra-bottom">
          <p>境外服务体系145家机构+34家调处中心+服务商+星使</p>
        </div>
        
        <!-- 右侧信息 -->
        <div class="coverage-info right-top">
          <p>服务范围全球(包括朝鲜,伊朗等)</p>
        </div>
        
        <div class="coverage-info right-middle">
          <p>服务网点60余万家</p>
        </div>
        
        <div class="coverage-info right-bottom">
          <p>签约服务商1182 家</p>
        </div>
        
        <div class="coverage-info right-extra-bottom">
          <p>双语星便3299 人</p>
        </div>
      </div>
    </section>
    <!-- 平台系统 - 四大系统模块展示 -->
    <section class="platform-system">
      <div class="container">
        <h2 class="section-title">平台系统</h2>
        <div class="system-modules">
          <!-- 系统1：紧急救援管理系统 -->
          <div class="system-module">
            <div class="module-icon">
              <img src="@/assets/images/rescueAlliance/business1.png" alt="紧急救援管理">
            </div>
            <h3>紧急救援管理系统</h3>
          </div>
          
          <!-- 系统2：全球资源调度系统 -->
          <div class="system-module">
            <div class="module-icon">
              <img src="@/assets/images/rescueAlliance/business2.png" alt="资源调度系统">
            </div>
            <h3>全球资源调度系统</h3>
          </div>
          
          <!-- 系统3：风险评估预警系统 -->
          <div class="system-module">
            <div class="module-icon">
              <img src="@/assets/images/rescueAlliance/business3.png" alt="风险评估系统">
            </div>
            <h3>风险评估预警系统</h3>
          </div>
          
          <!-- 系统4：客户服务管理系统 -->
          <div class="system-module">
            <div class="module-icon">
              <img src="@/assets/images/rescueAlliance/business4.png" alt="客户服务系统">
            </div>
            <h3>客户服务管理系统</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 大救星平台入口 - 网站与小程序入口 -->
    <section class="platform-entry">
      <div class="container">
        <div class="entry-content">
          <!-- 官方网站入口 -->
          <div class="entry-web">
            <h3>大救星官方网站</h3>
            <div class="entry-image">
              <img src="@/assets/images/rescueAlliance/website-preview.png" alt="大救星官方网站">
            </div>
            <button class="entry-btn" @click="gotoDjx">点击访问</button>
          </div>
          
          <!-- 微信小程序入口 -->
          <div class="entry-app">
            <h3>大救星微信小程序</h3>
            <div class="entry-image">
              <img src="@/assets/images/rescueAlliance/qrcode.png" alt="大救星微信小程序二维码">
            </div>
            <button class="entry-btn">微信扫码进入</button>
          </div>
        </div>
      </div>
    </section>

    <loginOrRegister ref="loginOrRegister"></loginOrRegister>
  </div>
</template>

<script>
import WorldMap from '../components/WorldMap.vue'
import * as echarts from 'echarts';
import loginOrRegister from '@/components/loginOrRegister.vue'

export default {
  name: 'RescueAlliance',
  components: {
    WorldMap,
    loginOrRegister
  },
  data() {
    return {
      mapData2: [
        { name: "欧洲", value: 62 },
        { name: "亚洲", value: 89 },
        { name: "非洲", value: 10 },
        { name: "北美洲", value: 7 },
        { name: "拉丁美洲", value: 7 },
        { name: "大洋洲", value:14 },
      ],
    };
  },
  mounted() {
    // 在组件挂载后添加窗口大小变化的监听器
    window.addEventListener("resize", this.resizeHandler, false);
  },
  beforeUnmount() {
    // 在组件销毁前移除监听器，避免内存泄漏
    window.removeEventListener("resize", this.resizeHandler);
  },
  activated() {
    window.addEventListener("resize", this.resizeHandler, false);
  },
  deactivated() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  methods: {
    // 处理窗口大小变化的方法
    resizeHandler() {
      const mapChart = echarts.init(document.getElementById("worldMap"));
      mapChart && mapChart.resize();
    },
    gotoDjx() {
      window.open('https://www.dajiuxing.com.cn', '_blank');
    },
    showLoginModal() {
      this.$refs.loginOrRegister.showLoginModal('register')
    }
  },
}
</script>

<style scoped>
/* ========== 基础样式 ========== */
.rescue-alliance {
  width: 100%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

section {
  padding: 80px 0;
}

/* ========== 通用标题样式 ========== */
.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  padding-bottom: 1rem;
  color: #333;
  font-weight: 600;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background-color: #0052D9;
}

/* ========== 按钮样式 ========== */
.btn-primary {
  background-color: #0052D9;
  color: white;
  border: none;
  padding: 14px 32px;
  font-size: 1.1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 82, 217, 0.2);
}

.btn-primary:hover {
  background-color: #003EB3;
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 82, 217, 0.3);
}

.btn-secondary {
  background-color: #fff;
  color: #0047b3;
  border: 2px solid #0047b3;
  padding: 10px 25px;
  font-size: 1.1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-secondary:hover {
  background-color: #0047b3;
  color: #fff;
}

/* ========== 主视觉区域样式 ========== */
.hero {
  background-image: url('@/assets/images/rescueAlliance/banner.png');
  background-size: cover;
  background-position: center;
  height: 500px;
  display: flex;
  align-items: center;
  color: #fff;
  position: relative;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  text-align: center;
  margin: 0 auto;
}

.hero h1 {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.hero p {
  font-size: 1.8rem;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* ========== 联盟介绍区域样式 ========== */
.alliance-intro {
  background-color: #f9f9f9;
}

.intro-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.intro-content p {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #555;
}

/* ========== 联盟成员分布区域样式 ========== */
.distribution-map {
  width: 100%;
  height: 400px;
  position: relative;
}

.distribution-map img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* ========== 联盟成员区域样式 ========== */
.alliance-members {
  background-color: #f9f9f9;
  padding: 60px 0;
}

.members-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.member-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid #eaeaea;
}

.member-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.member-item-img {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0 10px 0;
  border-bottom: 1px dashed #eaeaea;
}

.member-item-img img {
  max-width: 80%;
  max-height: 60px;
  object-fit: contain;
  margin-bottom: 15px;
}

.member-item-img h3 {
  color: #333;
  font-size: 1rem;
  font-weight: 500;
  margin: 0 0 10px 0;
}

.member-info {
  padding: 15px;
  text-align: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.member-info p {
  color: #666;
  font-size: 0.85rem;
  margin: 0;
}

/* ========== 加入联盟区域样式 ========== */
.join-alliance {
  color: #fff;
  text-align: center;
}

.join-content {
  background: linear-gradient(135deg, #073A90, #073A90);
  color: #fff;
  padding: 50px;
  border-radius: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  box-shadow: 0 15px 30px rgba(0, 82, 217, 0.2);
}

.join-content h2 {
  font-size: 2.5rem;
  margin-bottom: 30px;
}

.join-alliance .btn-primary {
  background-color: #fff;
  color: #0047b3;
}

.join-alliance .btn-primary:hover {
  background-color: #f0f0f0;
}

/* ========== 救援平台区域样式 ========== */
.rescue-platform {
  overflow: hidden;
  background-image: url('@/assets/images/rescueAlliance/banner-bg.png');
  background-size: cover;
  background-position: center;
}

.platform-content {
  display: flex;
  align-items: center;
  gap: 50px;
}

.platform-logo {
  background-color: #fff;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  flex: 0 0 200px;
  line-height: 200px;
  text-align: center;
  box-sizing: border-box;
  padding: 20px;
}

.platform-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.platform-text {
  flex: 1;
}

.platform-text h2 {
  font-size: 2.5rem;
  color: #FFFFFF;
  margin-bottom: 10px;
}

.platform-text h3 {
  font-size: 1.5rem;
  color: #FFFFFF;
  margin-bottom: 20px;
}

.platform-text p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #FFFFFF;
}

/* ========== 大救星平台服务覆盖区域样式 ========== */
.platform-coverage {
  width: 100%;
  height: 600px;
  background-image: url('@/assets/images/rescueAlliance/world-map-bg.png');
  background-size: cover;
  background-position: center;
  position: relative;
  /* background: linear-gradient(90deg, #00a97e 0%, #006e91 100%); */
  overflow: hidden;
}

/* .platform-coverage::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/rescueAlliance/world-map-dots.png');
  background-size: cover;
  background-position: center;
  opacity: 0.25;
} */

.coverage-container {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.platform-logo-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 180px;
  height: 180px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 2px dashed #00a97e;
  z-index: 2;
}

.platform-logo-center img {
  width: 80%;
  height: auto;
}

.coverage-info {
  position: absolute;
  background-color: rgba(0, 53, 69, 0.7);
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  width: 320px;
  z-index: 1;
  display: flex;
  align-items: center;
  height: 70px;
}

.coverage-info p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.4;
  text-align: left;
  width: 100%;
}

/* 左右定位 */
.left-top, .left-middle, .left-bottom, .left-extra-bottom {
  left: 10%;
}

.right-top, .right-middle, .right-bottom, .right-extra-bottom {
  right: 10%;
}

/* 垂直位置分布 */
.left-top, .right-top {
  top: 15%;
}

.left-middle, .right-middle {
  top: 35%;
}

.left-bottom, .right-bottom {
  top: 55%;
}

.left-extra-bottom, .right-extra-bottom {
  top: 75%;
}

/* ========== 服务特色区域样式 ========== */
.service-features {
  padding: 80px 0;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.feature-item {
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: transform 0.3s, box-shadow 0.3s;
  background-color: #fff;
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.feature-title {
  color: #333;
  font-size: 1rem;
  font-weight: 600;
  padding: 15px 0px;
  border-bottom: 1px solid #073A90;
  background-color: #fff;
  position: relative;
  margin: 0 10px;
}

.feature-content {
  padding: 15px;
  flex-grow: 1;
}

.feature-content p {
  color: #666;
  font-size: 0.85rem;
  line-height: 1.6;
  margin: 0;
  text-align: left;
}

/* ========== 平台系统区域样式 ========== */
.platform-system {
  background-color: #f8f8f8;
}

.system-modules {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

.system-module {
  flex: 1;
  text-align: center;
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.system-module:hover {
  transform: translateY(-10px);
}

.module-icon {
  margin-bottom: 20px;
}

.module-icon img {
  width: 100px;
  height: 100px;
}

.system-module h3 {
  color: #0047b3;
  font-size: 1.2rem;
}

/* ========== 平台入口区域样式 ========== */
.platform-entry {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.entry-content {
  display: flex;
  justify-content: center;
  gap: 60px;
  max-width: 1000px;
  margin: 0 auto;
}

.entry-web, .entry-app {
  background-color: #fff;
  border-radius: 8px;
  padding: 30px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  max-width: 450px;
  min-height: 400px;
  justify-content: space-between;
}

.entry-web h3, .entry-app h3 {
  font-size: 1.4rem;
  color: #333;
  margin-bottom: 25px;
  font-weight: 500;
  text-align: center;
}

.entry-image {
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.entry-web .entry-image img,
.entry-app .entry-image img {
  border: none;
  padding: 0;
  border-radius: 0;
}

.entry-btn {
  background-color: #0F3B81;
  color: white;
  border: none;
  padding: 10px 0;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 160px;
  text-align: center;
}

.entry-btn:hover {
  background-color: #0c2d62;
}

/* ========== 联系我们区域样式 ========== */
.contact-us {
  background-color: #f8f8f8;
}

.contact-info {
  display: flex;
  justify-content: space-between;
  max-width: 900px;
  margin: 0 auto;
}

.info-item {
  flex: 1;
  text-align: center;
  padding: 0 20px;
}

.info-item h3 {
  color: #0047b3;
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.info-item p {
  font-size: 1.1rem;
}

/* ========== 响应式设计 ========== */
/* 大屏幕设备 (最大宽度: 1200px) */
@media (max-width: 1200px) {
  .container {
    max-width: 960px;
  }
  
  .members-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 20px;
  }
  
  .coverage-info {
    width: 240px;
    padding: 12px 15px;
  }
  
  .coverage-info p {
    font-size: 0.9rem;
  }
}

/* 中等屏幕设备 (最大宽度: 992px) */
@media (max-width: 992px) {
  .container {
    max-width: 720px;
  }
  
  .hero {
    height: 400px;
  }
  
  .platform-content {
    flex-direction: column;
    text-align: center;
  }
  
  .system-modules {
    flex-wrap: wrap;
  }
  
  .system-module {
    flex: 0 0 calc(50% - 15px);
    margin-bottom: 30px;
  }
  
  .entry-content {
    gap: 30px;
  }
  
  .entry-web, .entry-app {
    padding: 20px;
    margin-bottom: 40px;
  }
  
  .platform-coverage {
    height: 800px;
  }
  
  .coverage-info {
    width: 220px;
  }
  
  .left-top, .right-top {
    top: 10%;
  }
  
  .left-middle, .right-middle {
    top: 33%;
  }
  
  .left-bottom, .right-bottom {
    top: 54%;
  }
  
  .left-extra-bottom, .right-extra-bottom {
    top: 75%;
  }
}

/* 小屏幕设备 (最大宽度: 768px) */
@media (max-width: 768px) {
  .container {
    max-width: 540px;
  }
  
  .hero {
    height: 550px;
    background-image: url('@/assets/images/rescueAlliance/banner-h5.png');
  }
  
  .hero h1 {
    font-size: 2.5rem;
  }
  
  .hero p {
    font-size: 1.3rem;
  }
  
  .members-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .contact-info {
    flex-direction: column;
  }
  
  .info-item {
    margin-bottom: 30px;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .entry-content {
    flex-direction: column;
    align-items: center;
  }
  
  .entry-web, .entry-app {
    width: 100%;
    max-width: 450px;
    margin-bottom: 30px;
  }
  
  .entry-image {
    min-height: 180px;
  }
  
  .platform-coverage {
    height: 1200px;
  }
  
  .coverage-info {
    width: 80%;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%);
  }
  
  .platform-logo-center {
    top: 10%;
  }
  
  .left-top {
    top: 25%;
  }
  
  .right-top {
    top: 35%;
  }
  
  .left-middle {
    top: 45%;
  }
  
  .right-middle {
    top: 55%;
  }
  
  .left-bottom {
    top: 65%;
  }
  
  .right-bottom {
    top: 75%;
  }
  
  .left-extra-bottom {
    top: 85%;
  }
  
  .right-extra-bottom {
    top: 95%;
  }
}

/* 超小屏幕设备 (最大宽度: 576px) */
@media (max-width: 576px) {
  .hero {
    height: 400px;
  }
  
  .members-grid, .features-grid {
    grid-template-columns: 1fr;
  }
  
  .system-module {
    flex: 0 0 100%;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .entry-web, .entry-app {
    padding: 15px;
  }
  
  .entry-web h3, .entry-app h3 {
    font-size: 1.2rem;
  }
  
  .entry-image {
    min-height: 150px;
  }
  
  .entry-app .entry-image img {
    width: 130px;
    height: 130px;
  }
}

/* 极小屏幕设备 (最大宽度: 480px) */
@media (max-width: 480px) {
  .hero h1 {
    font-size: 1.8rem;
  }
  
  .hero p {
    font-size: 1rem;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  .btn-primary {
    padding: 12px 25px;
    font-size: 1rem;
  }
}
</style> 